import { Component, OnInit } from '@angular/core';
import { BillersService } from '../../../services/billers.service'
import { ActivatedRoute } from '@angular/router';



@Component({
  selector: 'app-biller5',
  templateUrl: './biller5.component.html',
  styleUrls: ['./biller5.component.scss']
})
export class Biller5Component implements OnInit {

  trans_key
  payment_source_success
  constructor(public billerService : BillersService, public activatedRoute : ActivatedRoute) { }

  ngOnInit(): void {
    this.trans_key=this.activatedRoute.snapshot.paramMap.get("trans_key")
    this.activatedRoute.queryParams.subscribe(params => {
      this.payment_source_success =  params['payment-source-qr']
    })
  }

}
